/**
 * Public OAuth client ids the Turnkey provider needs explicitly.
 *
 * A Turnkey identity is `iss + aud + sub`, and `aud` is the client id, so the
 * SAME person signing in with two different client ids lands in two different
 * sub-organizations — with their wallets in only one of them. Web and mobile
 * each carried their own copy of this value and drifted apart, which split
 * real accounts and locked people out of their own wallets. One exported
 * constant is the fix: there is nothing left to drift.
 *
 * Do not reintroduce a per-platform env var for these. If an environment ever
 * needs a different OAuth application, make that explicit here rather than in
 * a build-time variable that only one platform reads.
 */

/**
 * Real X (Twitter) OAuth 2.0 client id.
 *
 * Passed explicitly because the auth proxy's `oauthClientIds.x` returns the
 * Turnkey credential id (a UUID) instead of this value, which x.com rejects on
 * the authorize request. Public, non-secret, and network-independent — the
 * Turnkey organization is a singleton across devnet and mainnet. Drop this once
 * the proxy publishes the credential's stored client id.
 */
export const TURNKEY_X_CLIENT_ID = 'OVR0RDV6YjhVSEk2RWVIakJRU3c6MTpjaQ';
